import dayjs from "dayjs";

export const STORAGE_KEY = "si:nt-addon-banner-closed";

export const getCurrentMonth = (): string => dayjs().format("YYYY-MM");

export const shouldShowBanner = (): boolean => {
    const closedDate = localStorage.getItem(STORAGE_KEY);

    if (!closedDate) {
        return true;
    }

    const currentMonth = getCurrentMonth();

    if (closedDate !== currentMonth) {
        localStorage.removeItem(STORAGE_KEY);
        return true;
    }

    return false;
};
